import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
    RadarChart,
    PolarAngleAxis,
    PolarRadiusAxis,
    PolarGrid,
    Radar,
    Legend,
    ResponsiveContainer,
    Tooltip
} from 'recharts';
import EdgeOrREST from '../../EdgeOrREST';
import { API_OBJECTS } from '../../API/model/calculation.model';
import Loading from '../shared/loading.component';

const numberFormatter = item => item.toFixed(2);

const Polar = () => {
    const state = useSelector(state => state);
    const [array, setArray] = useState({ 0: [], 90: [], 25: [] });
    const [loading, setLoading] = useState(true);

    const keys = Object.keys(array);
    const remainingKey = keys.find(key => key !== "0" && key !== "90") ?? "25";
    const A = array["90"];
    const B = array["0"];
    const C = array[remainingKey];
    const remainingKeyAdded = parseFloat(remainingKey) + 180;

    const data = useMemo(() => {
        if (!A || A.length === 0) return [];
        return A.map((_, i) => ({
            A: A[i],
            B: B[i],
            C: C[i],
            angle: i
        }));
    }, [A, B, C]);

    const handlePlot = useCallback((response) => {
        if (response?.data && response.status === 200) {
            setLoading(true);
            setArray(response.data);

            const timeout = setTimeout(() => {
                setLoading(false);
            }, 500);

            return () => clearTimeout(timeout);
        }
    }, []);

    useEffect(() => {
        const shouldFetch =
            (!array["0"]?.length && !array["90"]?.length) ||
            !!state.LuminaireCfg.selectedLuminaireIds?.length;

        if (shouldFetch) {
            setLoading(true);
            EdgeOrREST(null, "GET_POLAR", handlePlot, API_OBJECTS.getCalculationObject(state, null, null));
        }
    }, [state.LuminaireCfg.selectedLuminaireIds, handlePlot]);
    
    return (
        <div style={{ width: '100%', height: '500px' }}>
            {loading ? (
                <Loading type="circular" height={500} text={state.LuminaireCfg.selectedResultLuminId > 0 ? "Loading Polar Plot..." : "Please Select a Luminaire..."}/>
            ) : (
                <ResponsiveContainer width="100%" height={500}>
                    <RadarChart id="polarChart" cx="50%" cy="50%" startAngle={-90} endAngle={270} data={data}>
                        <PolarGrid gridType="circle" polarAngles={[0, 30, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330]} />
                        <PolarAngleAxis type="number" dataKey="angle" tickCount={13} ticks={[0, 90, 180]} />
                        <PolarRadiusAxis angle={90} type="number" fontSize={16} orientation="left" domain={['auto', 'auto']} />
                        <Radar name="270/90" dataKey="A" stroke="#8884d8" fillOpacity={0} />
                        <Radar name="180/0" dataKey="B" stroke="#ff0000" fillOpacity={0} />
                        <Radar name={`${remainingKeyAdded}/${remainingKey}`} dataKey="C" stroke="#50C878" fillOpacity={0} />
                        <Tooltip isAnimationActive={false} formatter={numberFormatter} />
                        <Legend />
                    </RadarChart>
                </ResponsiveContainer>
            )}
        </div>
    );
};

export default Polar;
